import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { IconComponent } from '@program-suite/util-icons';
import { ButtonComponent } from '@program-suite/ui';
import { EnvironmentStore } from '@program-suite/data-common';

@Component({
  selector: 'lib-footer',
  imports: [ButtonComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  environment = inject(EnvironmentStore);
  companyName = input<string>('');
  externalLink = 'external-link';
  curentYear = new Date().getFullYear();
}
